import './bml-header.scss';
const TEMPLATE = `
<header>
    <nav class="navbar">
        <div class="container-fluid">
            <a class="navbar-brand" href="/">
                <img src="/images/logo-header.svg?v=2" class="img-fluid" alt="BML Logo">
            </a>

            <!-- Mobile: Phone button (visible on mobile only, next to burger) -->
            <div class="mobile-phone-btn">
                <a href="tel:" class="phone-number-text mobile-phone-btn__link"
                   data-content="phone_number"
                   data-page="Home"
                   data-global="true"></a>
            </div>

            <!-- Desktop: Phone + drawer toggle -->
            <div class="header-right">
                <div class="phone-number">
                    <a href="tel:" class="btn phone-number-text"
                       data-content="phone_number"
                       data-page="Home"
                       data-global="true"></a>
                </div>
                <button class="desktop-drawer-toggle" id="drawer-toggle" type="button" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>

            <!-- Mobile collapse menu (with circles + addresses) — placed before togglers so CSS ~ selector works -->
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item text-center mt-4">
                        <a class="nav-link" href="/about-us">Про нас</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/doslidzhennya">Дослідження</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/cases">Діагностичні кейси</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/about-work">Як це працює</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/#cooperation">Партнерство</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/certificates">Сертифікати</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/vacancies">Кар'єра</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/news-feed">Новини</a>
                    </li>
                    <li class="nav-item text-center">
                        <a class="nav-link" href="/contacts">Контакти</a>
                    </li>
                    <li class="header-city" style="margin-top: 115px;">
                        <p class="city-name">Київ</p>
                        <p>+38 044 344 32 93</p>
                        <p>26/4-Б Бульвар Тараса Шевченка</p>
                    </li>
                    <li class="header-city" style="margin-top: 20px;">
                        <p class="city-name">Львів</p>
                        <p>+38 044 333 43 08</p>
                        <p>вул. Стрийська, 33</p>
                    </li>
                </ul>

                <div class="burger-circle-container">
                    <div class="burger-circle burger-circle-large"></div>
                    <div class="burger-circle burger-circle-medium"></div>
                    <div class="burger-circle burger-circle-small"></div>
                </div>
            </div>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Mobile: Close button -->
            <button class="close-burger-btn" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="true" aria-label="Close navigation">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="42" height="42" rx="10.5" fill="#0090B8"/>
                    <rect x="11.708" y="28.8076" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(-45 11.708 28.8076)" fill="white"/>
                    <rect x="13.1929" y="11.708" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(45 13.1929 11.708)" fill="white"/>
                </svg>
            </button>
        </div>
    </nav>

    <!-- Desktop side drawer (no circles, no addresses) -->
    <div class="drawer-overlay" id="drawer-overlay"></div>
    <div class="side-drawer" id="side-drawer">
        <div class="side-drawer__header">
            <a class="navbar-brand side-drawer__brand" href="/">
                <img src="/images/logo-drawer.svg?v=2" class="img-fluid" alt="BML Logo">
            </a>
            <button class="side-drawer__close" id="drawer-close" type="button" aria-label="Close navigation">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="42" height="42" rx="10.5" fill="#0090B8"/>
                    <rect x="11.708" y="28.8076" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(-45 11.708 28.8076)" fill="white"/>
                    <rect x="13.1929" y="11.708" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(45 13.1929 11.708)" fill="white"/>
                </svg>
            </button>
        </div>
        <nav class="side-drawer__nav">
            <ul>
                <li><a href="/about-us">Про нас</a></li>
                <li><a href="/doslidzhennya">Дослідження</a></li>
                <li><a href="/cases">Діагностичні кейси</a></li>
                <li><a href="/about-work">Як це працює</a></li>
                <li><a href="/#cooperation">Партнерство</a></li>
                <li><a href="/certificates">Сертифікати</a></li>
                <li><a href="/vacancies">Кар'єра</a></li>
                <li><a href="/news-feed">Новини</a></li>
                <li><a href="/contacts">Контакти</a></li>
            </ul>
        </nav>
        <div class="side-drawer__contacts">
            <div class="side-drawer__city">
                <p class="side-drawer__city-name">Київ</p>
                <a href="tel:+380443334308">+38 044 333 43 08</a>
                <a href="https://maps.google.com/?q=26/4-%D0%91+%D0%91%D1%83%D0%BB%D1%8C%D0%B2%D0%B0%D1%80+%D0%A2%D0%B0%D1%80%D0%B0%D1%81%D0%B0+%D0%A8%D0%B5%D0%B2%D1%87%D0%B5%D0%BD%D0%BA%D0%B0,%D0%9A%D0%B8%D1%97%D0%B2"
                   target="_blank">вул. Т.Шевченка, 26/4-Б</a>
            </div>
            <div class="side-drawer__city">
                <p class="side-drawer__city-name">Львів</p>
                <a href="tel:+380443334308">+38 044 333 43 08</a>
                <a href="https://maps.google.com/?q=%D0%92%D1%83%D0%BB.+%D0%A1%D1%82%D1%80%D0%B8%D0%B9%D1%81%D1%8C%D0%BA%D0%B0,+33,%D0%9B%D1%8C%D0%B2%D1%96%D0%B2"
                   target="_blank">вул. Стрийська, 33</a>
            </div>
        </div>
    </div>
</header>
`;

class BmlHeader extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
        this._onScroll = () => {
            this.classList.toggle('is-scrolled', window.scrollY > 10);
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();

        this.querySelectorAll('.phone-number-text').forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const phone = el.textContent.trim().replace(/[^+\d]/g, '');
                if (phone) window.location.href = `tel:${phone}`;
            });
        });
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
    }
}

customElements.define('bml-header', BmlHeader);
